import { debounce } from '../core/utils/debounce.js';

function updateRevealHeight(reveal) {
    const content = reveal.querySelector('.read-reveal__content');
    if (content) {
        const inner = content.firstElementChild;
        if (inner) {
            const height = inner.offsetHeight;
            content.style.setProperty('--height', `${height}px`);

            if (content.offsetHeight >= height) {
                reveal.setAttribute('aria-expanded', 'true');
            }
        }
    }
}

function updateAllRevealHeights() {
    document.querySelectorAll('.read-reveal').forEach(updateRevealHeight);
}

export function initializeReadRevealListeners() {
    const handleResize = debounce(updateAllRevealHeights, 200);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
}

export function initializeReadReveal(container = document) {
    const reveals = container.querySelectorAll('.read-reveal');

    reveals.forEach(reveal => {
        if (reveal.classList.contains('js-read-reveal-init')) return;
        reveal.classList.add('js-read-reveal-init');

        updateRevealHeight(reveal);

        const btn = reveal.querySelector('.read-reveal__btn');
        if (btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const isExpanded = reveal.getAttribute('aria-expanded') === 'true';
                reveal.setAttribute('aria-expanded', !isExpanded);
                updateRevealHeight(reveal);
            });
        }
    });
}